import React from "react";
import TenantForm from "../Components/TenantForm";

const TenantFormPage = () => {
  return <TenantForm />;
};

export default TenantFormPage;
